export default [
  {
    text: '#',
    value: 'id',
    width: '10%',
  },
  {
    text: 'nombre',
    value: 'name',
    width: '60%',
  },
  {
    text: 'cantidad productos',
    value: 'product_quantity',
    align: 'right',
    width: '10%',
  },
  {
    text: 'inicio',
    value: 'init_datetime',
    align: 'right',
    format: 'date',
    width: '10%',
  },
  {
    text: 'término',
    value: 'finish_datetime',
    align: 'right',
    format: 'date',
    width: '10%',
  },
]
